// import { BannerDesign1 } from './designs/BannerDesign1';
// import { BannerDesign2 } from './designs/BannerDesign2';

// type DesignName = 'design1' | 'design2';

// interface WidgetData {
//   token: string;
//   customClassName?: string;
//   type: string;
//   version: string;
//   module?: string;
//   design?: DesignName;
// }

// export class SearchComponent {
//   private widgetData: WidgetData;
//   private response: any = {};
//   private language: string = 'en';
//   private debounceDelay = 400;
//   private debounceTimer: number | null = null;

//   private bannerInstance: any;
//   private containerElement: HTMLDivElement;
//   private autocompleteInput!: HTMLInputElement;
//   private autocompleteList!: HTMLUListElement;

//   constructor(widgetData: WidgetData) {
//     this.widgetData = widgetData;
//     this.language = this.response?.language || 'en';

//     // pick design
//     this.bannerInstance =
//       this.widgetData.design === 'design2'
//         ? new BannerDesign2(this.language, this.widgetData, this.response)
//         : new BannerDesign1(this.language, this.widgetData, this.response);

//     this.containerElement = this.bannerInstance.getContainer();
//     this.autocompleteInput = this.bannerInstance.getInput();
//     this.autocompleteList = this.bannerInstance.getList();

//     this.setupEventListeners();
//   }

//   render(parentElement: HTMLElement): void {
//     this.initialRender();
//     parentElement.appendChild(this.containerElement);
//   }

//   /* ------------------ events & interactions ------------------ */

//   private setupEventListeners(): void {
//     // input (debounced)
//     this.autocompleteInput.addEventListener('input', this.debouncedHandleInput.bind(this));

//     // clicking a suggestion
//     this.autocompleteList.addEventListener('click', this.handleItemClick.bind(this));

//     // messages from iframe or host
//     window.addEventListener('message', (event) => {
//       const { type, res } = (event && event.data) || {};

//       // validate module key presence
//       const moduleKey = this.widgetData.module || 'trade-in';

//       if (type === `${moduleKey}-modal-close`) {
//         // clear input and close iframe
//         this.autocompleteInput.value = '';
//         this.handleIframeClose();
//       } else if (
//         type === `${moduleKey}-modal-open` &&
//         res?.success &&
//         res?.widgetName === 'Trade-In' &&
//         res?.type === 'banner'
//       ) {
//         // store server response (theme/colors/etc) and show banner
//         this.response = res;
//         // set CSS variable for primary color (design CSS uses var(--primary-color))
//         this.containerElement.style.setProperty('--primary-color', res?.primaryColor || '#5e50f1');
//         this.containerElement.style.visibility = 'visible';

//         // optionally preload iframe or other side effects
//         this.initialRender();
//       }
//     });
//   }

//   private debouncedHandleInput(): void {
//     if (this.debounceTimer) window.clearTimeout(this.debounceTimer);
//     this.debounceTimer = window.setTimeout(() => this.handleInput(), this.debounceDelay);
//   }

//   private async handleInput(): Promise<void> {
//     const searchText = this.autocompleteInput.value.trim();
//     if (!searchText) {
//       this.clearAutocompleteList();
//       return;
//     }

//     const apiUrl = `https://api.dabadu.ai/inventory/api/vehicles/blackbook/autocomplete?searchText=${encodeURIComponent(
//       searchText
//     )}`;

//     try {
//       const response = await fetch(apiUrl, { headers: { 'Content-Type': 'application/json' } });
//       if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

//       const data = await response.json();
//       this.updateAutocompleteList(data?.message?.autocomplete || []);
//     } catch (error) {
//       // keep user-friendly console trace but don't break
//       console.error('Error fetching autocomplete data:', error);
//     }
//   }

//   private updateAutocompleteList(items: any[]): void {
//     // create safe list items with data attributes used later
//     this.autocompleteList.innerHTML = items
//       .map(
//         (item) =>
//           `<li data-description="${escapeHtml(item.description)}" data-make="${escapeHtml(
//             item.make
//           )}" data-model="${escapeHtml(item.model)}" data-model_year="${escapeHtml(
//             item.model_year
//           )}" data-series="${escapeHtml(item.series)}" data-uvc="${escapeHtml(item.uvc)}">
//             ${escapeHtml(item.description)}
//           </li>`
//       )
//       .join('');

//     this.autocompleteList.style.display = items.length > 0 ? 'block' : 'none';
//   }

//   private clearAutocompleteList(): void {
//     this.autocompleteList.innerHTML = '';
//     this.autocompleteList.style.display = 'none';
//   }

//   private handleItemClick(event: MouseEvent): void {
//     const target = event.target as HTMLLIElement;
//     if (!target) return;

//     const vehicleData = {
//       heading: target.getAttribute('data-description'),
//       make: target.getAttribute('data-make'),
//       model: target.getAttribute('data-model'),
//       year: target.getAttribute('data-model_year'),
//       trim: target.getAttribute('data-series'),
//       uvc: target.getAttribute('data-uvc'),
//     };

//     // open iframe with selected vehicle
//     this.launchIframe(vehicleData);

//     this.autocompleteInput.value = vehicleData.heading || '';
//     this.clearAutocompleteList();
//   }

//   /* ------------------ iframe / preload ------------------ */

//   private launchIframe(vehicleData: any): void {
//     this.handleIframeClose(); // close existing

//     const iframe = document.createElement('iframe');

//     // iframe.src = `http://localhost:5173/trade-in/${this.widgetData.token}?${new URLSearchParams(
//     //   vehicleData
//     // ).toString()}&domain=${window.location.origin}&type=${this.widgetData.type}&version=${this.widgetData.version}`;

//     iframe.src = `https://uat-widget.apps.dabadu.ai/trade-in/${this.widgetData.token}?${new URLSearchParams(
//       vehicleData
//     ).toString()}&domain=${window.location.origin}&type=${this.widgetData.type}&version=${this.widgetData.version}`;

//     iframe.style.cssText =
//       'border:none;display:block;position:fixed;width:100vw;height:100vh;top:0;left:0;z-index:1000000;';
//     iframe.id = 'trade-in';

//     document.body.appendChild(iframe);
//     document.body.style.overflow = 'hidden';
//   }

//   private handleIframeClose(): void {
//     const iframe = document.getElementById('trade-in');
//     if (iframe) {
//       iframe.remove();
//       document.body.style.overflow = '';
//     }
//   }

//   initialRender() {
//     // preload hidden iframe (used by some flows)
//     const iframeId = 'trade-in';
//     if (document.getElementById(iframeId)) return;

//     const iframe = document.createElement('iframe');
//     iframe.name = iframeId;

//     // iframe.src = `http://localhost:5173/trade-in/${this.widgetData.token}?domain=${window.location.origin}&type=${this.widgetData.type}&version=${this.widgetData.version}`;

//     iframe.src = `https://uat-widget.apps.dabadu.ai/trade-in/${this.widgetData.token}?domain=${window.location.origin}&type=${this.widgetData.type}&version=${this.widgetData.version}`;
//     iframe.style.display = 'none';
//     iframe.id = iframeId;

//     document.body.appendChild(iframe);
//   }
// }

// /* ---------- small helper ---------- */
// function escapeHtml(input: any) {
//   if (input == null) return '';
//   return String(input).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
// }

import { BannerDesign1 } from './designs/BannerDesign1';
import { BannerDesign2 } from './designs/BannerDesign2';

type DesignName = 'design1' | 'design2';

interface WidgetData {
  token: string;
  customClassName?: string;
  type: string;
  version: string;
  module?: string;
  design?: DesignName;
}

export class SearchComponent {
  private widgetData: WidgetData;
  private response: any = {};
  private language: string = 'en';

  // elements that are created only after success
  private bannerInstance: any = null;
  private containerElement: HTMLDivElement | null = null;
  private autocompleteInput: HTMLInputElement | null = null;
  private autocompleteList: HTMLUListElement | null = null;

  // ids that include token (deterministic)
  private containerId: string;
  private preloadIframeId: string;

  // render mount (where to append when created)
  private mountPoint: HTMLElement | null = null;

  // debounce
  private debounceDelay = 400;
  private debounceTimer: number | null = null;

  constructor(widgetData: WidgetData) {
    this.widgetData = widgetData;
    this.language = this.response?.language || 'en';

    this.containerId = `trade-in-banner-${this.widgetData.token}`;
    this.preloadIframeId = `trade-in-preload-${this.widgetData.token}`;

    // Important: do not create container here. Only setup event listeners.
    this.setupEventListeners();

    // Preload (optional) — note: we will still create a token-specific hidden iframe only once
    // but we won't create the UI container until validated. This mirrors AffordabilityBanner.
    this.preloadIframe();
  }

  /**
   * Public render. If container already exists, append immediately. Otherwise store mount
   * and append once container gets created after validation.
   */
  render(parentElement: HTMLElement): void {
    this.mountPoint = parentElement;
    if (this.containerElement && !this.containerElement.parentElement) {
      parentElement.appendChild(this.containerElement);
    }
  }

  /* ------------------ event listeners & lifecycle ------------------ */

  private setupEventListeners(): void {
    // input/list click listeners will be bound after container creation (in bindUIEvents)

    // messages from iframe or host
    window.addEventListener('message', (event) => {
      // defensive logging for debugging
      console.debug('[SearchComponent] postMessage', event?.origin, event?.data);

      const { type, res } = (event && event.data) || {};
      const moduleKey = this.widgetData.module || 'trade-in';

      if (!type?.startsWith(moduleKey)) return;
      if (res?.accessToken && res.accessToken !== this.widgetData.token) return;

      // close message — remove runtime iframe & clear input
      if (type === `${moduleKey}-modal-close`) {
        if (this.autocompleteInput) this.autocompleteInput.value = '';
        this.handleIframeClose();
        return;
      }

      // open/validation message — create UI only on success
      if (type === `${moduleKey}-modal-open`) {
        // success -> create UI and show
        if (res?.success && res?.widgetName === 'Trade-In' && res?.type === 'banner') {
          this.response = res;
          // if UI not created, create it now
          if (!this.containerElement) {
            this.createAndAttachContainer();
          }

          // apply theming and show
          if (this.containerElement) {
            this.containerElement.style.setProperty('--primary-color', res?.primaryColor || '#5e50f1');
            this.containerElement.style.visibility = 'visible';
          }

          // ensure preload iframe exists (optional)
          this.preloadIframe();

          console.debug('[SearchComponent] validation success, showing UI', res);
        } else {
          // failure -> token invalid or auth failed -> ensure we remove any preloaded iframe / container
          console.warn('[SearchComponent] validation failed or not success, removing UI and preloads', res);

          // remove container if attached
          const existing = document.getElementById(this.containerId);
          if (existing && existing.parentNode) {
            existing.remove();
          }
          this.containerElement = null;
          this.bannerInstance = null;
          this.autocompleteInput = null;
          this.autocompleteList = null;

          // remove preloaded iframe if present
          const pre = document.getElementById(this.preloadIframeId);
          if (pre && pre.parentNode) pre.remove();

          // remove runtime iframe (if open)
          const runtimeIframe = document.getElementById('trade-in');
          if (runtimeIframe && runtimeIframe.parentNode) {
            runtimeIframe.remove();
            document.body.style.overflow = '';
          }
        }
      }
    });
  }

  /* ------------------ create UI lazily ------------------ */

  /**
   * Creates bannerInstance and container, binds UI events, then appends to mount if available.
   */
  private createAndAttachContainer(): void {
    // create design instance (bannerInstance is responsible for HTML structure)
    this.bannerInstance =
      this.widgetData.design === 'design2'
        ? new BannerDesign2(this.language, this.widgetData, this.response)
        : new BannerDesign1(this.language, this.widgetData, this.response);

    // get container from design (assuming design returns a DIV wrapper)
    const container = this.bannerInstance.getContainer();
    if (!(container instanceof HTMLDivElement)) {
      // fallback: wrap in a div if design returned something unexpected
      const wrapper = document.createElement('div');
      wrapper.id = this.containerId;
      wrapper.style.visibility = 'hidden';
      wrapper.className = 'tradein-banner-wrapper';
      wrapper.appendChild(container);
      this.containerElement = wrapper;
    } else {
      container.id = this.containerId;
      // ensure hidden until validation applied
      container.style.visibility = 'hidden';
      this.containerElement = container;
    }

    // get input/list from design instance (may return undefined if design doesn't expose)
    // fallback selectors if design doesn't provide getters
    if (typeof this.bannerInstance.getInput === 'function') {
      this.autocompleteInput = this.bannerInstance.getInput();
    } else {
      this.autocompleteInput = this.containerElement.querySelector('input[type="text"]');
    }

    if (typeof this.bannerInstance.getList === 'function') {
      this.autocompleteList = this.bannerInstance.getList();
    } else {
      this.autocompleteList = this.containerElement.querySelector('ul, div.tradein-autocomplete') as HTMLUListElement;
    }

    // apply optional custom class
    if (this.widgetData.customClassName) {
      this.containerElement.classList.add(this.widgetData.customClassName);
    }

    // if mount point already provided via render(), append
    if (this.mountPoint) {
      // avoid double-append
      if (!this.containerElement.parentElement) {
        this.mountPoint.appendChild(this.containerElement);
      }
    } else {
      // default append to body to match earlier behaviour
      if (!this.containerElement.parentElement) {
        document.body.appendChild(this.containerElement);
      }
    }

    // bind UI events (input + clicks)
    this.bindUIEvents();
  }

  private bindUIEvents(): void {
    if (this.autocompleteInput) {
      // ensure we don't add duplicate listeners
      this.autocompleteInput.addEventListener('input', this.debouncedHandleInputBound);
    }
    if (this.autocompleteList) {
      this.autocompleteList.addEventListener('click', this.handleItemClickBound);
    }
  }

  // bound functions to allow removeEventListener if needed in future
  private debouncedHandleInputBound = (e: Event) => this.debouncedHandleInput(e);
  private handleItemClickBound = (e: MouseEvent) => this.handleItemClick(e);

  /* ------------------ autocomplete flow ------------------ */

  private debouncedHandleInput(e: Event): void {
    if (this.debounceTimer) window.clearTimeout(this.debounceTimer);
    this.debounceTimer = window.setTimeout(() => this.handleInput(e), this.debounceDelay);
  }

  private async handleInput(e: Event): Promise<void> {
    const inputEl = e.target as HTMLInputElement;
    const searchText = (inputEl?.value || '').trim();
    if (!searchText) {
      this.clearAutocompleteList();
      return;
    }

    const apiUrl = `https://api.dabadu.ai/inventory/api/vehicles/blackbook/autocomplete?searchText=${encodeURIComponent(
      searchText
    )}`;

    try {
      const response = await fetch(apiUrl, { headers: { 'Content-Type': 'application/json' } });
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const data = await response.json();
      const items = data?.message?.autocomplete || [];
      this.updateAutocompleteList(items);
    } catch (err) {
      console.error('SearchComponent handleInput error', err);
      this.clearAutocompleteList();
    }
  }

  private updateAutocompleteList(items: any[]): void {
    if (!this.autocompleteList) return;

    // if design expects UL li, map to li; else use simple divs
    const isUl = this.autocompleteList.tagName?.toLowerCase() === 'ul';
    if (isUl) {
      this.autocompleteList.innerHTML = items
        .map(
          (item) =>
            `<li data-description="${escapeHtml(item.description)}" data-make="${escapeHtml(
              item.make
            )}" data-model="${escapeHtml(item.model)}" data-model_year="${escapeHtml(
              item.model_year
            )}" data-series="${escapeHtml(item.series)}" data-uvc="${escapeHtml(item.uvc)}">
              ${escapeHtml(item.description)}
            </li>`
        )
        .join('');
    } else {
      this.autocompleteList.innerHTML = items
        .map(
          (item) =>
            `<div class="tradein-option" data-description="${escapeHtml(item.description)}" data-make="${escapeHtml(
              item.make
            )}" data-model="${escapeHtml(item.model)}" data-model_year="${escapeHtml(
              item.model_year
            )}" data-series="${escapeHtml(item.series)}" data-uvc="${escapeHtml(item.uvc)}">
              ${escapeHtml(item.description)}
            </div>`
        )
        .join('');
    }

    // show the list
    (this.autocompleteList as HTMLElement).style.display = items.length > 0 ? 'block' : 'none';
  }

  private clearAutocompleteList(): void {
    if (!this.autocompleteList) return;
    this.autocompleteList.innerHTML = '';
    (this.autocompleteList as HTMLElement).style.display = 'none';
  }

  private handleItemClick(e: MouseEvent): void {
    const target = e.target as HTMLElement;
    if (!target) return;

    // find nearest element with data-description
    const el = target.closest('[data-description]') as HTMLElement | null;
    if (!el) return;

    const vehicleData = {
      heading: el.getAttribute('data-description') || '',
      make: el.getAttribute('data-make') || '',
      model: el.getAttribute('data-model') || '',
      year: el.getAttribute('data-model_year') || '',
      trim: el.getAttribute('data-series') || '',
      uvc: el.getAttribute('data-uvc') || '',
    };

    // open iframe with selected vehicle
    this.launchIframe(vehicleData);

    // set input and clear list
    if (this.autocompleteInput) this.autocompleteInput.value = vehicleData.heading;
    this.clearAutocompleteList();
  }

  /* ------------------ iframe / preload / close ------------------ */

  private launchIframe(vehicleData: any): void {
    // close any existing runtime iframe
    this.handleIframeClose();

    const iframe = document.createElement('iframe');
    iframe.id = 'trade-in';
    iframe.name = 'trade-in';

    iframe.src = `https://widget-v1.dabadu.dev/trade-in/${this.widgetData.token}?${new URLSearchParams(
      vehicleData
    ).toString()}&domain=${window.location.origin}&type=${this.widgetData.type}&version=${this.widgetData.version}`;

    iframe.style.cssText =
      'border:none;display:block;position:fixed;width:100vw;height:100vh;top:0;left:0;z-index:1000000;';

    document.body.appendChild(iframe);
    // lock scroll
    document.body.style.overflow = 'hidden';
  }

  private handleIframeClose(): void {
    const runtimeIframe = document.getElementById('trade-in');
    if (runtimeIframe && runtimeIframe.parentNode) {
      runtimeIframe.remove();
      document.body.style.overflow = '';
    }
  }

  /**
   * Preload hidden iframe for faster open flows. Uses a token-specific id so it can be removed if validation fails.
   */
  private preloadIframe(): void {
    const iframeId = this.preloadIframeId;
    if (document.getElementById(iframeId)) return;

    const iframe = document.createElement('iframe');
    iframe.name = iframeId;
    iframe.id = iframeId;
    iframe.src = `https://widget-v1.dabadu.dev/trade-in/${this.widgetData.token}?domain=${window.location.origin}&type=${this.widgetData.type}&version=${this.widgetData.version}`;
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
  }
}

/* ---------- small helper ---------- */
function escapeHtml(input: any) {
  if (input == null) return '';
  return String(input).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
